import {Component, Input, OnInit} from '@angular/core';
import {componentColorType} from "../../types/component-color.type";
import {IconAction} from "../../model/icon-action.model";

@Component({
  selector: 'app-icon-circle',
  templateUrl: './icon-circle.component.html',
  styleUrls: ['./icon-circle.component.scss'],
})
export class IconCircleComponent  implements OnInit {

  @Input() type: componentColorType;
  @Input() action: IconAction;

  constructor() { }

  ngOnInit() {}

}
